<template lang="pug">
	
	div.float-box-content.col-12
		
		ul.nav.justify-content-center.nav-icons.row

			li.nav-item.col-3
				a.nav-link(href='#', @click="abrirTela('SHAPE')", :class="{ active: tela === 'SHAPE' }")
					i.mdi.mdi-upload
					small Shape

			li.nav-item.col-3
				a.nav-link(href='#', @click="abrirTela('POLIGONO')", :class="{ active: tela === 'POLIGONO' }")
					i.mdi.mdi-vector-square
					small Polígono

			li.nav-item.col-3
				a.nav-link(href='#', @click="abrirTela('LINHA')", :class="{ active: tela === 'LINHA' }")
					i.mdi.mdi-vector-line
					small Linha

			li.nav-item.col-3
				a.nav-link(href='#', @click="abrirTela('PONTO')", :class="{ active: tela === 'PONTO' }")
					i.mdi.mdi-crosshairs-gps
					small Ponto

		alert.alert-sm(v-show="showSuccess", 
				msg="Nova camada adicionada com sucesso.", 
				type="success", 
				:showTitle="false", 
				:closeFunction="hideSuccess")
				
		div.float-box-default-padding(v-show="tela === 'SHAPE'")

			adicao-camada-shape(ref="SHAPE", 
					@adicionarCamada="adicionarCamada", 
					@limpar="hideSuccess")

		div.float-box-default-padding(v-show="tela === 'POLIGONO'")
			
			adicao-camada-geometria(ref="POLIGONO", 
					:tipoGeometria="TipoGeometria.POLIGONO"
					@adicionarCamada="adicionarCamada", 
					@limpar="hideSuccess")
			
		div.float-box-default-padding(v-show="tela === 'LINHA'")
			
			adicao-camada-geometria(ref="LINHA", 
					:tipoGeometria="TipoGeometria.LINHA",
					@adicionarCamada="adicionarCamada", 
					@limpar="hideSuccess")

		div.float-box-default-padding(v-show="tela === 'PONTO'")
			
			adicao-camada-geometria(ref="PONTO", 
					:tipoGeometria="TipoGeometria.PONTO",
					@adicionarCamada="adicionarCamada", 
					@limpar="hideSuccess")

</template>

<script>

import Alert from '@/components/utils/Alert';
import AdicaoCamadaShape from './AdicaoCamadaShape';
import AdicaoCamadaGeometria from './AdicaoCamadaGeometria';
import TipoGeometria from '@/models/tipoGeometria';
import Estilo from '@/models/estilo';
import { mapMutations } from 'vuex';

export default {
	
	name: 'AdicaoCamadas',

	componentOptions: {

		title: 'Nova Camada',

		actions: [
			[
				{
					name: 'Adicionar nova camada',
					iconClass: 'mdi mdi-lead-pencil',
					showView: true
				}
			]
		]
	},

	components: { Alert, AdicaoCamadaShape, AdicaoCamadaGeometria },

	data () {
		return {
			tela: 'SHAPE',
			geoJsonShape: null,
			showSuccess: false,
			ultimaCamadaAdicionada: null,
			TipoGeometria: TipoGeometria
		};
	},

	mounted () {

		this.$bus.$on('mapa.camadaAdicionada', (camada) => {

			if (this.ultimaCamadaAdicionada &&
				(camada === this.ultimaCamadaAdicionada || camada.id === this.ultimaCamadaAdicionada.id)) {

				this.ultimaCamadaAdicionada = null;
			}
		});
	},

	methods: {

		abrirTela (tela) {

			if (tela === this.tela) return;

			this.hideSuccess();

			var componenteAtual = this.$refs[this.tela];
			var componenteNovo = this.$refs[tela];

			if (componenteAtual.removerGeometriasMapa) componenteAtual.removerGeometriasMapa();

			if (componenteNovo.adicionarGeometriasMapa) componenteNovo.adicionarGeometriasMapa();

			this.tela = tela;
		},

		hideSuccess () {

			this.showSuccess = false;
		},

		getComponenteTelaAtiva () {

			if (!this.tela) return null;

			return this.$refs[this.tela];
		},

		adicionarCamada (options) {

			var camada = this.criarCamada(options);
			this.ultimaCamadaAdicionada = camada;
			this.adicionarCamadaUsuario(camada);
			this.ativarCamada(camada);

			this.showSuccess = true;
		},

		criarCamada (options) {

			var tipoGeometria = TipoGeometria.getFromGeoJson(options.geoJson);

			var estilo = Estilo.criarEstiloCamadaUsuario(options.cor, tipoGeometria);
			estilo.padrao = true;
			
			return {
				nome: options.nome,
				geoJson: options.geoJson,
				visualizacao: {
					mapa: true,
					marcador: false
				},
				estiloPadrao: estilo,
				tipoGeometria: tipoGeometria
			};
		},

		// Método chamado pelo componente pai (ToolBox)
		beforeComponentHide () {

			this.$bus.$emit('mapa.cancelDraw');

			var componente = this.getComponenteTelaAtiva();
			
			if (componente && componente.removerGeometriasMapa) {
				
				componente.removerGeometriasMapa();
			}
		},

		// Método chamado pelo componente pai (ToolBox)
		afterComponentShow () {

			var componente = this.getComponenteTelaAtiva();
			
			if (componente && componente.adicionarGeometriasMapa) {
				
				componente.adicionarGeometriasMapa();
			}
		},

		...mapMutations([
			'adicionarCamadaUsuario',
			'ativarCamada'
		])
	}
};

</script>


<style lang="scss">

	.alert {
		margin-top: 5px;
		margin-bottom: 0px;
	}

</style>



// WEBPACK FOOTER //
// AdicaoCamadas.vue?38120617